import React from 'react';
import FontAwesomeIcon from 'src/components/Icon';
import "./BulkSummaryHeader.scss";

interface BulkSummaryHeaderProps {
  title: string;
  subtitle: React.ReactNode;
  centered?: boolean;
}

const BulkSummaryHeader = ({ title, subtitle, centered = false }: BulkSummaryHeaderProps) => {
  return (
    <div className={`bulk-op-header ${centered ? 'is-centered' : ''}`}>
      <div className="bulk-op-header-icon">
        <FontAwesomeIcon glyph="check-circle" weight="solid" size="large" />
      </div>
      <div className="bulk-op-header-content">
        <h3 className="bulk-op-header-title">{title}</h3>
        <div className="bulk-op-header-subtitle">{subtitle}</div>
      </div>
    </div>
  );
};

export default BulkSummaryHeader;